import { CategoryGroup, AnnualBudget } from '../types';

export const CATEGORIES: CategoryGroup = {
  生活开销: [
    '食品杂货',
    '外出就餐', 
    '交通',
    '服装配饰',
    '个人护理',
    '家居用品',
    '医疗保健',
    '宠物',
  ],
  自由开销: ['娱乐', '旅行', '教育', '礼品', '购物'],
  固定成本: ['住房', '水电费', '网络电话', '订阅服务', '保险'],
  储蓄与债务: ['储蓄', '债务偿还'],
  家庭贡献: ['家庭费用'],
};

export const ANNUAL_BUDGET: AnnualBudget = {
  住房: 4500,
  水电费: 300,
  网络电话: 200,
  订阅服务: 150,
  保险: 520,
  交通: 1500,
  食品杂货: 4000,
  外出就餐: 500,
  家居用品: 350,
  医疗保健: 200,
  服装配饰: 1500,
  个人护理: 1500,
  宠物: 260,
  娱乐: 3000,
  旅行: 6000,
  教育: 300,
  礼品: 200,
  购物: 200,
  储蓄: 10000,
  债务偿还: 3060,
  家庭费用: 4000,
};

export const MONTH_NAMES = [
  '一月', '二月', '三月', '四月', '五月', '六月',
  '七月', '八月', '九月', '十月', '十一月', '十二月'
];

export const CHART_COLORS = [
  '#64748b', '#71717a', '#a16207', '#166534', '#1d4ed8', '#7e22ce',
  '#be185d', '#78716c', '#f97316', '#16a34a', '#2563eb', '#9333ea',
  '#db2777', '#b91c1c',
];